import * as XLSX from 'xlsx';

const DownloadTransferExcel = (transferData, companyName, setOpenBackdrop) => {
    if (!transferData || transferData.length === 0) {
        alert("No data found to export!");
        return;
    }

    setOpenBackdrop(true);

    try {
        const rows = [];
        
        // Header
        rows.push([companyName.toUpperCase()]);
        rows.push(["SITE TRANSFER SUMMARY REPORT"]);
        rows.push([]);

        // Table Column Names
        const headers = [
            "Transfer ID", 
            "Date", 
            "From Customer", 
            "To Customer", 
            "Entry Type", 
            "Item Name", 
            "Qty", 
            "Rate", 
            "Amount"
        ];
        rows.push(headers);

        // Data Rows
        transferData.forEach((transfer) => {
            transfer.items.forEach((item, index) => {
                rows.push([
                    index === 0 ? transfer.from_challan?.challan_no || 'N/A' : "",
                    index === 0 ? new Date(transfer.created_at).toLocaleDateString() : "",
                    index === 0 ? transfer.from_customer?.contact_name : "",
                    index === 0 ? transfer.to_customer?.contact_name : "",
                    index === 0 ? (transfer.is_manual_entry ? "Manual" : "Auto") : "",
                    item.item_name,
                    Number(item.qty),
                    Number(item.rate),
                    Number(item.amount)
                ]);
            });
            // Gap between different transfers
            rows.push([]);
        });

        const worksheet = XLSX.utils.aoa_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Transfers");

        // Column widths
        worksheet['!cols'] = [
            { wch: 12 }, { wch: 15 }, { wch: 25 }, { wch: 25 }, 
            { wch: 12 }, { wch: 12 }, { wch: 10 }, { wch: 10 }, { wch: 12 }
        ];

        XLSX.writeFile(workbook, `Site_Transfer_Report_${new Date().getTime()}.xlsx`);
    } catch (error) {
        console.error("Excel Error:", error);
    } finally {
        setOpenBackdrop(false);
    }
};

export default DownloadTransferExcel;